import { importProvidersFrom } from '@angular/core';
import { Route } from '@angular/router';
import { HttpRemitosService } from '@daas-consulting/production/remitos/frontend/data_access';
import { RemitosServiceId } from '@daas-consulting/production/remitos/frontend/data_contracts';
import * as remitosStore from '@daas-consulting/production/remitos/frontend/store';
import { RemitosPrintPageViewContractId } from '@daas-consulting/production/remitos/frontend/view_contracts';
import { RemitosPrintPageViewModel } from '@daas-consulting/production/remitos/frontend/view_models';
import { NgxsModule } from '@ngxs/store';

export const RemitosPrintRoute: Route = {
  path: 'remitos/:id/print',
  providers: [
    importProvidersFrom(
      NgxsModule.forFeature([remitosStore.print.state.RemitosPrintState])
    ),
    { provide: RemitosServiceId, useClass: HttpRemitosService },
    {
      provide: RemitosPrintPageViewContractId,
      useClass: RemitosPrintPageViewModel,
    },
  ],
  loadComponent() {
    return import('@daas-consulting/production/remitos/frontend/pages').then(
      (c) => c.RemitosPrintPageComponent
    );
  },
  data: {
    action: 'print',
    subject: 'production.remitos.remito',
  },
};
